import { DayOpeningHours, OpeningHoursSchedule, WeekdayKey } from '../types/app';

export const WEEKDAY_KEYS: WeekdayKey[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

export const WEEKDAY_LABELS: Record<WeekdayKey, string> = {
  mon: 'Monday',
  tue: 'Tuesday',
  wed: 'Wednesday',
  thu: 'Thursday',
  fri: 'Friday',
  sat: 'Saturday',
  sun: 'Sunday',
};

export const DEFAULT_DAY_HOURS: DayOpeningHours = {
  closed: false,
  open: '11:00',
  close: '22:00',
};

export const DEFAULT_OPENING_HOURS: OpeningHoursSchedule = {
  mon: { ...DEFAULT_DAY_HOURS },
  tue: { ...DEFAULT_DAY_HOURS },
  wed: { ...DEFAULT_DAY_HOURS },
  thu: { ...DEFAULT_DAY_HOURS },
  fri: { ...DEFAULT_DAY_HOURS },
  sat: { ...DEFAULT_DAY_HOURS },
  sun: { ...DEFAULT_DAY_HOURS },
};

export const DEFAULT_CLOSED_MESSAGE =
  "We're currently closed. You can browse the menu, but online ordering will resume during our opening hours.";

export function normalizeTimeHHmm(value: string): string | null {
  const trimmed = value.trim();
  const match = trimmed.match(/^([01]?\d|2[0-3]):([0-5]\d)(?::[0-5]\d)?$/);
  if (!match) return null;
  return `${match[1].padStart(2, '0')}:${match[2]}`;
}

export function isValidTimeHHmm(value: string): boolean {
  return normalizeTimeHHmm(value) !== null;
}

export function normalizeDayHours(raw: unknown): DayOpeningHours {
  if (!raw || typeof raw !== 'object') return { ...DEFAULT_DAY_HOURS };
  const row = raw as Record<string, unknown>;
  const open =
    typeof row.open === 'string' ? normalizeTimeHHmm(row.open) ?? DEFAULT_DAY_HOURS.open : DEFAULT_DAY_HOURS.open;
  const close =
    typeof row.close === 'string' ? normalizeTimeHHmm(row.close) ?? DEFAULT_DAY_HOURS.close : DEFAULT_DAY_HOURS.close;
  return {
    closed: row.closed === true,
    open,
    close,
  };
}

export function normalizeOpeningHours(raw: unknown): OpeningHoursSchedule {
  const source = raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {};
  const next = { ...DEFAULT_OPENING_HOURS };
  for (const key of WEEKDAY_KEYS) {
    next[key] = normalizeDayHours(source[key]);
  }
  return next;
}
